import { useQuery } from '@tanstack/react-query';

import regularStatus from '../../regular/status';
import fetch from './fetch';

function useMtRatio() {
  const { cb, key } = fetch();

  const { isMtActive } = regularStatus.useAccountStatus();

  const enabled = isMtActive; // Do not call when user does not have MT account

  const { data, isSuccess, refetch } = useQuery(key, cb, { enabled });

  const isMtRatioExceeded = data?.margin_ratio >= data?.target_margin_ratio;

  return { data, isSuccess, refetch, isMtRatioExceeded };
}

export default {
  useMtRatio,
};
